import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import React from 'react';
import './css/site.css'
import './css/theme.css'
import ImageCompressor from './ImageOperations/ImageCompressor';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <App />
// );


let rootElement = document.getElementById('compress-image');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<ImageCompressor />);
}

